var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashPlotly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    viewBox: "0 0 25.6 25.6",
    width: 64,
    id: "svg32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs36"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style610"
  }, "\r\n      .cls-1 {\r\n        fill: #119dff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #25fefd;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "symbol",
    transform: "scale(0.19393939)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect616",
    ry: 6,
    rx: 6,
    height: 132,
    width: 132,
    className: "cls-1",
    x: 0,
    y: 0,
    style: {
      fill: "#119dff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle618",
    r: 6,
    cy: 54,
    cx: 78,
    className: "cls-2",
    style: {
      fill: "#25fefd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle620",
    r: 6,
    cy: 30,
    cx: 102,
    className: "cls-2",
    style: {
      fill: "#25fefd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle622",
    r: 6,
    cy: 30,
    cx: 78,
    className: "cls-2",
    style: {
      fill: "#25fefd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle624",
    r: 6,
    cy: 30,
    cx: 54,
    className: "cls-2",
    style: {
      fill: "#25fefd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle626",
    r: 6,
    cy: 30,
    cx: 30,
    className: "cls-2",
    style: {
      fill: "#25fefd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle628",
    r: 6,
    cy: 54,
    cx: 30,
    className: "cls-2",
    style: {
      fill: "#25fefd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path630",
    d: "m 30,72 a 6,6 0 0 0 -6,6 v 24 a 6,6 0 0 0 12,0 V 78 a 6,6 0 0 0 -6,-6 z",
    className: "cls-3",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path632",
    d: "m 78,72 a 6,6 0 0 0 -6,6 v 24 a 6,6 0 0 0 12,0 V 78 a 6,6 0 0 0 -6,-6 z",
    className: "cls-3",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path634",
    d: "m 54,48 a 6,6 0 0 0 -6,6 v 48 a 6,6 0 0 0 12,0 V 54 a 6,6 0 0 0 -6,-6 z",
    className: "cls-3",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path636",
    d: "m 102,48 a 6,6 0 0 0 -6,6 v 48 a 6,6 0 0 0 12,0 V 54 a 6,6 0 0 0 -6,-6 z",
    className: "cls-3",
    style: {
      fill: "#ffffff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashPlotly);
export default __webpack_public_path__ + "static/media/dash_plotly.7b8181c031ed5c2efacd1ab8e6ecfadd.svg";
export { ForwardRef as ReactComponent };